import PropTypes from 'prop-types';
import BaseSelectorReadonlyToInput from "../../component/Select/BaseSelectorReadonlyToInput";

class ReadpointTypeSelector extends BaseSelectorReadonlyToInput {

  constructor(props) {
    super(props);
    this.state = {
      ...this.state,
      label: 'name',
      title: 'Tipo',
      items: [
        {id: 'NODE', name: 'Node'},
        {id: 'MOVEL', name: 'Móvel'},
        {id: 'COMMISSIONER', name: 'Comissionador'},
        {id: 'STEREO', name: 'Estéreo'},
        {id: 'PORTAL', name: 'Portal'}
        ]
    };
  }
}

ReadpointTypeSelector.propTypes = {
  required: PropTypes.bool,
  setValue: PropTypes.func,
  defaultValue: PropTypes.string,
  readonly: PropTypes.bool,
  onChange: PropTypes.func,
};

export default ReadpointTypeSelector;



// WEBPACK FOOTER //
// ./src/readpoint/component/ReadpointTypeSelector.js